import { useState } from "react";
import { api, inr } from "./utils";
import { Link } from "react-router-dom";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function AdminSearch() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const go = async () => {
    if (!q.trim()) return;
    setLoading(true); setErr("");
    try {
      const { data } = await api.get(`/admin/search?q=${encodeURIComponent(q.trim())}`);
      setRes(data);
    } catch (e) { setErr(e?.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-4" data-testid="admin-search">
      <div className="nb-card p-3 flex items-center gap-2">
        <MagnifyingGlass size={16} weight="bold" />
        <input
          data-testid="global-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") go(); }}
          placeholder="Search businesses, end customers, invoice #, phone…"
          className="nb-input flex-1 px-3 py-2 text-sm"
        />
        <button data-testid="search-go" onClick={go} className="nb-btn bg-[#4361EE] text-white text-xs px-3 py-2">Search</button>
      </div>

      {err && <div className="nb-card p-3 bg-[#FF6B6B] text-white text-sm font-bold">{err}</div>}
      {loading && <p className="text-sm">Searching…</p>}

      {res && (
        <div className="grid lg:grid-cols-3 gap-4">
          <Section title={`Businesses (${res.businesses.length})`} testid="search-businesses">
            {res.businesses.length === 0 ? <p className="text-sm text-[#4A4A4A]">No matches</p> : res.businesses.map((b) => (
              <Link key={b.user_id} to={`/admin/businesses/${b.user_id}`} className="block border-b border-black/10 py-2 hover:bg-[#FDFBF7]">
                <div className="font-bold text-sm">{b.business_name || b.name}</div>
                <div className="text-[11px] text-[#4A4A4A]">{b.email}</div>
              </Link>
            ))}
          </Section>
          <Section title={`End customers (${res.customers.length})`} testid="search-customers">
            {res.customers.length === 0 ? <p className="text-sm text-[#4A4A4A]">No matches</p> : res.customers.map((c) => (
              <Link key={c.customer_id} to={`/admin/businesses/${c.user_id}`} className="block border-b border-black/10 py-2 hover:bg-[#FDFBF7]">
                <div className="font-bold text-sm">{c.name}</div>
                <div className="text-[11px] text-[#4A4A4A]">{c.phone}</div>
              </Link>
            ))}
          </Section>
          <Section title={`Invoices (${res.invoices.length})`} testid="search-invoices">
            {res.invoices.length === 0 ? <p className="text-sm text-[#4A4A4A]">No matches</p> : res.invoices.map((i) => (
              <Link key={i.invoice_id} to={`/admin/businesses/${i.user_id}`} className="block border-b border-black/10 py-2 hover:bg-[#FDFBF7]">
                <div className="font-bold text-sm">{i.invoice_number}</div>
                <div className="text-[11px] text-[#4A4A4A]">{inr(i.amount)}</div>
              </Link>
            ))}
          </Section>
        </div>
      )}
    </div>
  );
}

function Section({ title, testid, children }) {
  return (
    <div className="nb-card p-4" data-testid={testid}>
      <h3 className="font-heading font-black text-lg mb-2">{title}</h3>
      {children}
    </div>
  );
}
